import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'background' || groupKey === 'hero-image' || groupKey === 'feature-image'
      ? section?.media?.primary
      : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseWealthDetailHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    category: fields.eyebrow || '',
    title: fields.title,
    description: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
    image: getMediaUrl(section, 'hero-image'),
  };
};

export const parseWealthDetailEarnContent = (page) => {
  const section = getSection(page, 'earn');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const paragraphs = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`paragraph-${index}`];
    if (!value) {
      break;
    }
    paragraphs.push(value);
  }

  return {
    title: fields.title,
    paragraphs,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseWealthDetailCoreParametersContent = (page) => {
  const section = getSection(page, 'core-parameters');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`parameter-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`parameter-${index}-text`] || '',
      icon: getMediaUrl(section, `parameter-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'Core Parameters',
    items,
  };
};

export const parseWealthDetailSavingsContent = (page) => {
  const section = getSection(page, 'savings');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.text) {
    return null;
  }

  return {
    quote: fields.text,
    eagleImage: getMediaUrl(section, 'eagle-image'),
  };
};

export const parseWealthDetailAccountFeaturesContent = (page) => {
  const section = getSection(page, 'account-features');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 20; index += 1) {
    const label = fields[`feature-${index}-label`];
    if (!label) {
      break;
    }

    items.push({
      label,
      value: fields[`feature-${index}-value`] || '',
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'Account Features',
    items,
  };
};

export const parseWealthDetailGrowthContent = (page) => {
  const section = getSection(page, 'growth');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
  };
};

export const parseWealthDetailContent = (page) => {
  if (!page) {
    return null;
  }

  return {
    hero: parseWealthDetailHeroContent(page),
    earn: parseWealthDetailEarnContent(page),
    coreParameters: parseWealthDetailCoreParametersContent(page),
    savings: parseWealthDetailSavingsContent(page),
    accountFeatures: parseWealthDetailAccountFeaturesContent(page),
    growth: parseWealthDetailGrowthContent(page),
  };
};
